import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isPhoneDevice, isSmallTouchDevice as smallTouchDeviceDetect } from '@mummssoftware/utils/web';
import { DEFAULT_LOG_LEVEL, LOG_LEVEL_PRIORITY, AUTO_FLUSH_LEVEL, FLUSH_INTERVAL } from './config';
import { LOG_LEVEL, PROTOCOL } from './constants';
import { extendIfDefined, isBrowser, formatStringForPost } from './util';
import { LoggerApi } from './loggerApi';
import { initializeLoggerListeners } from './loggerListeners';
const isMobile = isPhoneDevice();
const isSmallTouchDevice = smallTouchDeviceDetect();
export function Logger({
  url,
  prefix,
  metricNamespacePrefix,
  logLevel = DEFAULT_LOG_LEVEL,
  flushInterval = FLUSH_INTERVAL,
  patientInfo,
  userInfo
}) {
  var _window, _window$clientInforma, _window2, _window2$clientInform, _window3, _window3$clientInform, _window4, _window4$clientInform, _window4$clientInform2;

  let events = [];
  let tracking = [];
  let metrics = [];
  let loggerUrl = url;
  let loggerPrefix = prefix;
  let loggerLogLevel = logLevel;
  let loggerFlushInterval = flushInterval;
  const payloadBuilders = [];
  const metaBuilders = [];
  const trackingBuilders = [];
  const metricDimensionBuilders = [];
  const headerBuilders = [];
  let loggerApi;
  const clientData = {
    clientAppVersion: ((_window = window) === null || _window === void 0 ? void 0 : (_window$clientInforma = _window.clientInformation) === null || _window$clientInforma === void 0 ? void 0 : _window$clientInforma.appVersion) || 'Unknown Client App Version',
    clientPlatform: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$clientInform = _window2.clientInformation) === null || _window2$clientInform === void 0 ? void 0 : _window2$clientInform.platform) || 'Unknown Client Platform',
    clientLanguage: ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$clientInform = _window3.clientInformation) === null || _window3$clientInform === void 0 ? void 0 : _window3$clientInform.language) || 'Unknown Client Language',
    cleintConnectionType: ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$clientInform = _window4.clientInformation) === null || _window4$clientInform === void 0 ? void 0 : (_window4$clientInform2 = _window4$clientInform.connection) === null || _window4$clientInform2 === void 0 ? void 0 : _window4$clientInform2.effectiveType) || 'Unknown Client Connection Type',
    isMobile,
    isSmallTouchDevice
  };
  const patientData = {
    patientSiteName: (patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.siteName) || 'Unknown Patient Site Name',
    patientNumber: (patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.patientNumber) || 'Unknown Patient Number',
    patientHospiceBin: (patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.hospiceName) || 'Unknown Patient Hospice Bin'
  };
  const userData = {
    personNumber: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.personNumber) || 'Unknown Person Number',
    userSiteName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.siteName) || 'Unknown User Site Name',
    userHospiceBin: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.currentHospiceBin) || 'Unknown User Hospice Bin',
    userId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) || 'Unknown User ID',
    isMumms: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isMumms) || false,
    isHospiceAdmin: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isHospiceAdmin) || false
  };

  if (!loggerUrl) {
    throw new Error(`Error: Unable to instantiate logger; url for service is ${loggerUrl}`);
  } else {
    loggerApi = new LoggerApi(loggerUrl);
  }

  function print(level, event, payload) {
    if (!isBrowser() || !window.console || !window.console.log) {
      return;
    }

    if (LOG_LEVEL_PRIORITY.indexOf(level) > LOG_LEVEL_PRIORITY.indexOf(loggerLogLevel)) {
      return;
    }

    const args = [];
    args.push(event);
    args.push(payload);

    if (payload.error || payload.warning) {
      args.push('\n\n', payload.error || payload.warning);
    }

    switch (level) {
      case LOG_LEVEL.DEBUG:
        console.debug(`DEBUG: ${event}`, args);
        break;

      case LOG_LEVEL.INFO:
        console.info(`INFO: ${event}`, args);
        break;

      case LOG_LEVEL.WARN:
        console.warn(`WARN: ${event}`, args);
        break;

      case LOG_LEVEL.ERROR:
        console.error(`ERROR: ${event}`, args);
        break;

      default:
        console.log(event, args);
        break;
    }
  }

  const immediateFlush = () => {
    if (!isBrowser() || window.location.protocol === PROTOCOL.FILE) {
      return;
    }

    if (!events.length && !tracking.length && !metrics.length) {
      return;
    }

    const meta = {}; // eslint-disable-next-line no-restricted-syntax

    for (const builder of metaBuilders) {
      extendIfDefined(meta, builder(meta));
    }

    const headers = {}; // eslint-disable-next-line no-restricted-syntax

    for (const builder of headerBuilders) {
      extendIfDefined(headers, builder(headers));
    }

    if (loggerUrl) {
      loggerApi.sendLog({
        events,
        meta,
        tracking,
        metrics
      });
    }

    events = [];
    tracking = [];
    metrics = [];
  }; // Queued flush - add a call to immediateFlush to the process queue


  const flush = () => {
    setTimeout(immediateFlush, 0);
  };

  function enqueue(level, event, payload) {
    events.push({
      level,
      event,
      payload
    });

    if (AUTO_FLUSH_LEVEL.indexOf(level) !== -1) {
      flush();
    }
  }

  function log(level, event, payload = {}) {
    let lEvent = event;

    if (!isBrowser()) {
      return logger; // eslint-disable-line no-use-before-define
    }

    if (loggerPrefix && !lEvent) {
      lEvent = `${loggerPrefix}_${event}`;
    }

    const logPayload = _objectSpread(_objectSpread({}, payload), {}, {
      timestamp: Date.now().toString()
    }); // eslint-disable-next-line no-restricted-syntax


    for (const builder of payloadBuilders) {
      extendIfDefined(logPayload, builder(logPayload));
    }

    enqueue(level, lEvent, logPayload);
    print(level, lEvent, logPayload);
    return logger; // eslint-disable-line no-use-before-define
  }

  function addBuilder(builders, builder) {
    builders.push(builder);
    return logger; // eslint-disable-line no-use-before-define
  }

  function addPayloadBuilder(builder) {
    return addBuilder(payloadBuilders, builder);
  }

  function addMetaBuilder(builder) {
    return addBuilder(metaBuilders, builder);
  }

  function addTrackingBuilder(builder) {
    return addBuilder(trackingBuilders, builder);
  }

  function addMetricDimensionBuilder(builder) {
    return addBuilder(metricDimensionBuilders, builder);
  }

  function addHeaderBuilder(builder) {
    return addBuilder(headerBuilders, builder);
  }

  const debug = (name, payload) => log(LOG_LEVEL.DEBUG, name, payload);

  const info = (name, payload) => log(LOG_LEVEL.INFO, name, payload);

  const warn = (name, payload) => log(LOG_LEVEL.WARN, name, payload);

  const error = (name, payload) => log(LOG_LEVEL.ERROR, name, payload);

  function constructErrorEvent(event) {
    return event || 'Unknown Error';
  }

  const constructErrorPayloadFromErrorEvent = event => {
    var _event$error, _event$error2, _event$error3, _event$error4, _event$error5, _event$error6;

    console.log('error', error);
    console.log('payload', _objectSpread(_objectSpread(_objectSpread({
      message: formatStringForPost((_event$error = event.error) === null || _event$error === void 0 ? void 0 : _event$error.message) || 'Unknown Error',
      stack: formatStringForPost((_event$error2 = event.error) === null || _event$error2 === void 0 ? void 0 : _event$error2.stack),
      errorName: (_event$error3 = event.error) === null || _event$error3 === void 0 ? void 0 : _event$error3.name,
      filename: event.filename,
      lineno: event.lineno,
      timestamp: event.timeStamp
    }, clientData), userData), patientData));
    return _objectSpread(_objectSpread(_objectSpread({
      message: formatStringForPost((_event$error4 = event.error) === null || _event$error4 === void 0 ? void 0 : _event$error4.message) || 'Unknown Error',
      stack: formatStringForPost((_event$error5 = event.error) === null || _event$error5 === void 0 ? void 0 : _event$error5.stack),
      errorName: (_event$error6 = event.error) === null || _event$error6 === void 0 ? void 0 : _event$error6.name,
      filename: event.filename,
      lineno: event.lineno,
      timestamp: event.timeStamp
    }, clientData), userData), patientData);
  };

  const constructErrorPayloadFromPromiseRejectionEvent = event => {
    var _event$reason, _event$reason2;

    console.log('promise rejection', event);
    return _objectSpread(_objectSpread(_objectSpread({
      message: formatStringForPost((_event$reason = event.reason) === null || _event$reason === void 0 ? void 0 : _event$reason.message) || 'Unknown Error',
      stack: formatStringForPost((_event$reason2 = event.reason) === null || _event$reason2 === void 0 ? void 0 : _event$reason2.stack),
      timestamp: event.timeStamp
    }, clientData), userData), patientData);
  };

  function handleOnErrorEvent(event) {
    var _event$error7;

    event.preventDefault();
    const lEvent = constructErrorEvent((_event$error7 = event.error) === null || _event$error7 === void 0 ? void 0 : _event$error7.message);
    const lPayload = constructErrorPayloadFromErrorEvent(event);
    log(LOG_LEVEL.ERROR, lEvent, lPayload);
  }

  function handleUnhandledRejection(event) {
    event.preventDefault();
    const lEvent = constructErrorEvent(event.reason.message);
    const lPayload = constructErrorPayloadFromPromiseRejectionEvent(event);
    log(LOG_LEVEL.ERROR, lEvent, lPayload);
  }

  function track(payload = {}) {
    if (!isBrowser()) {
      return logger; // eslint-disable-line no-use-before-define
    }

    const trackingPayload = _objectSpread({}, payload); // eslint-disable-next-line no-restricted-syntax


    for (const builder of trackingBuilders) {
      extendIfDefined(trackingPayload, builder(trackingPayload));
    }

    print(LOG_LEVEL.DEBUG, 'track', trackingPayload);
    tracking.push(trackingPayload);
    return logger; // eslint-disable-line no-use-before-define
  }

  function metric(metricPayload) {
    if (!isBrowser()) {
      return logger; // eslint-disable-line no-use-before-define
    }

    if (metricNamespacePrefix) {
      metricPayload.metricNamespace = `${metricNamespacePrefix}:${metricPayload.metricNamespace}`;
    }

    if (metricDimensionBuilders.length > 0 && !metricPayload.dimensions) {
      metricPayload.dimensions = {};
    } // eslint-disable-next-line no-restricted-syntax


    for (const builder of metricDimensionBuilders) {
      extendIfDefined(metricPayload.dimensions || {}, builder(metricPayload.dimensions || {}));
    }

    print(LOG_LEVEL.DEBUG, `metric.${metricPayload.metricNamespace}`, metricPayload.dimensions || {});
    metrics.push(metricPayload);
    return logger; // eslint-disable-line no-use-before-define
  }

  function metricCounter(metricPayload) {
    var _metricPayload$value;

    return metric({
      name: metricPayload.event,
      metricEventName: metricPayload.event,
      metricNamespace: metricPayload.namespace,
      metricValue: (_metricPayload$value = metricPayload.value) !== null && _metricPayload$value !== void 0 ? _metricPayload$value : 1,
      metricType: 'counter',
      dimensions: metricPayload.dimensions
    });
  }

  function metricGauge(metricPayload) {
    return metric({
      name: metricPayload.event,
      metricNamespace: metricPayload.namespace,
      metricEventName: metricPayload.event,
      metricValue: metricPayload.value,
      metricType: 'gauge',
      dimensions: metricPayload.dimensions
    });
  }

  function configure(opts) {
    if (opts.url) {
      loggerUrl = opts.url;
    }

    if (opts.prefix) {
      loggerPrefix = opts.prefix;
    }

    if (opts.logLevel) {
      loggerLogLevel = opts.logLevel;
    }

    if (opts.flushInterval) {
      loggerFlushInterval = opts.flushInterval;
    }

    return logger; // eslint-disable-line no-use-before-define
  }

  const addListeners = () => {
    console.log(`Adding event listeners!!`);
    initializeLoggerListeners({
      logger
    });
  };

  if (isBrowser()) {
    setTimeout(flush, loggerFlushInterval);
  }

  if (typeof window === 'object') {
    window.addEventListener('beforeunload', () => {
      immediateFlush();
    });
    window.addEventListener('unload', () => {
      immediateFlush();
    });
    window.addEventListener('pagehide', () => {
      immediateFlush();
    });
    window.addEventListener('error', handleOnErrorEvent);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
  }

  const logger = {
    debug,
    info,
    warn,
    error,
    track,
    metric,
    metricCounter,
    metricGauge,
    flush,
    immediateFlush,
    addPayloadBuilder,
    addMetaBuilder,
    addMetricDimensionBuilder,
    addTrackingBuilder,
    addHeaderBuilder,
    configure,
    addListeners,
    // exposed primarily for testing
    // exposes these buffers as readonly getters only
    __buffer__: {
      getEvents() {
        return events;
      },

      getTracking() {
        return tracking;
      },

      getMetrics() {
        return metrics;
      }

    }
  }; // mark the __buffer__ prop as readonly

  Object.defineProperty(logger, '__buffer__', {
    writable: false
  });
  return logger;
}